module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveButton/images/economics-selected-50.1e736a0c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveButton/images/economics-selected-50.png
// module id = 3440
// module chunks = 11